module.exports = {
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/projects.json
// module chunks = 4